import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';

/**
 * Route guard that prevents patients from accessing non-patient routes
 * Patients should only have access to /patient/* routes
 */
export function NonPatientRoute() {
  const { user } = useAuthStore();

  // If user is a patient, redirect to patient dashboard
  if (user?.role === 'Paciente') {
    return <Navigate to="/patient/dashboard" replace />;
  }

  return <Outlet />;
}
